import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentTypeChipProps } from '@modules/digital-signage/model/group-settings.model.ts';
import {
  CONTENT_TYPE_CHIP_CLASSES,
  CONTENT_TYPE_LABELS
} from '@modules/digital-signage/components/group-settings/utils/group-settings.utils.ts';

const ContentTypeChip: React.FC<ContentTypeChipProps> = ({ type }) => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="caption"
      component="span"
      className={`inline-flex! items-center h-5 px-2 rounded-full text-[11px]! font-semibold! leading-none! whitespace-nowrap shrink-0 ${CONTENT_TYPE_CHIP_CLASSES[type]}`}
    >
      {t(CONTENT_TYPE_LABELS[type])}
    </Typography>
  );
};

export default ContentTypeChip;
